import { aws } from './awsdb';

export async function logExportActivity(session, resourceLabel, detail) {
  if (!session) return;
  const { error } = await aws.from('forecaster_activity').insert([{
    actor_name: session.name,
    action: `Excel export: ${resourceLabel}`,
    detail: detail || null
  }]);
  if (error) console.warn('[export-activity-log] insert failed:', error.message);
}
